<div class="forgot-container">
  <mat-card class="forgot-card">

    <!-- Before submission -->
    <ng-container *ngIf="!submitted">
      <div class="forgot-header">
        <div class="forgot-icon-wrapper">
          <mat-icon>lock_reset</mat-icon>
        </div>
        <h2 class="forgot-title">Passwort vergessen?</h2>
        <p class="forgot-subtitle">Geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen ein Einmalpasswort zu.</p>
      </div>

      <div class="forgot-form">
        <form [formGroup]="forgotForm" (ngSubmit)="onSubmit()">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>E-Mail</mat-label>
            <mat-icon matPrefix>email</mat-icon>
            <input matInput type="email" formControlName="email" placeholder="ihre@email.com">
            <mat-error *ngIf="forgotForm.get('email')?.hasError('required')">
              E-Mail ist erforderlich
            </mat-error>
            <mat-error *ngIf="forgotForm.get('email')?.hasError('email')">
              Ungültige E-Mail-Adresse
            </mat-error>
          </mat-form-field>

          <div class="forgot-actions">
            <button mat-raised-button color="primary" class="forgot-submit-btn" type="submit"
                    [disabled]="!forgotForm.valid || isLoading">
              <mat-icon *ngIf="!isLoading">send</mat-icon>
              <mat-spinner *ngIf="isLoading" diameter="20" style="display:inline-block;margin-right:8px"></mat-spinner>
              {{ isLoading ? 'Wird gesendet...' : 'Einmalpasswort senden' }}
            </button>
            <div class="forgot-back">
              <a routerLink="/users/login">Zurück zur Anmeldung</a>
            </div>
          </div>
        </form>

        <p *ngIf="error" class="error-message">{{ error }}</p>
      </div>
    </ng-container>

    <!-- After successful submission -->
    <ng-container *ngIf="submitted">
      <div class="forgot-header">
        <div class="forgot-icon-wrapper success">
          <mat-icon>mark_email_read</mat-icon>
        </div>
        <h2 class="forgot-title">E-Mail gesendet!</h2>
        <p class="forgot-subtitle">
          Falls ein Konto mit dieser E-Mail existiert, wurde ein Einmalpasswort an
          <strong>{{ forgotForm.value.email }}</strong> gesendet.
        </p>
        <p class="forgot-hint">
          Melden Sie sich mit dem Einmalpasswort an und vergeben Sie anschließend ein neues Passwort.
        </p>
      </div>
      <div class="forgot-form">
        <button mat-raised-button color="primary" class="forgot-submit-btn" (click)="goToLogin()">
          <mat-icon>login</mat-icon>
          Zur Anmeldung
        </button>
      </div>
    </ng-container>

  </mat-card>
</div>
